import Select, { Props as SelectProps, StylesConfig } from "react-select";
import {
  IInputContainerProps,
  InputContainer,
} from "../Inputs/InputContainer/inputContainer";

type SelectInputProps = IInputContainerProps & SelectProps;

export const SimpleSelect = ({
  label,
  required,
  ...rest
}: SelectInputProps) => {
  const customStyles: StylesConfig = {
    control: (base, state) => ({
      ...base,
      border: state.isDisabled ? "1px solid #9d9d9d" : "1px solid #111",
      borderRadius: "10px",
      outline: "none",
      height: "44px",
      boxShadow: "none",
      background: state.isDisabled ? "rgba(239, 239, 239, 0.3)" : "none",
      "&:hover": {
        border: "1px solid #111",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      height: "44px",
      padding: "0 16px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    placeholder: (base) => ({
      ...base,
      height: "44px",
      lineHeight: "0",
      padding: "0",
      display: "flex",
      alignItems: "center",
    }),
    input: (base) => ({
      ...base,
      height: "44px",
      padding: "0",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 2,
    }),
  };

  return (
    <InputContainer label={label} required={required}>
      <Select {...rest} styles={customStyles} required={required} />
    </InputContainer>
  );
};
